module.exports = __webpack_public_path__ + "static/media/translations.1033.ca31e4f9.resx";